<template>
  <div class="filters-panel">
    <form>
      <dep-filter-group
        v-for="(fil, index) in visibleFiltros"
        ref="groups"
        v-bind:config="fil"
        :key="fil.name"
        v-bind:i="index"
        :moduleName="moduleName"
      >
      </dep-filter-group>
    </form>
    <button
      :disabled="isDisabledButton"
      class="filter-button btn-primary"
      v-if="showButton"
      @click="$emit('button-apply')"
    >
      {{ buttonText ? buttonText : "Aplicar" }}
    </button>
  </div>
</template>

<script>
import depFilterGroup from "@/components/global/depFilterGroup";
import { SET_STORAGE_NAME_FILTERS } from "@/vuex/mutation-types";

export default {
  components: {
    depFilterGroup,
  },
  props: ["moduleName", "showButton", "buttonText", "isDisabledButton"],
  data() {
    return {
      panelWidth: 0,
    };
  },
  computed: {
    filtros() {
      return this.$store.state[this.moduleName].filters.filters;
    },
    visibleFiltros() {
      this.filtros.forEach((f) => {
        if (f.name === "retos") {
          f.childs = f.childs.sort((a, b) => {
            return a.id - b.id;
          });
        }
      });

      return this.filtros.filter((f) => f.visible);
    },
  },
  mounted() {
    this.$store.commit(
      this.moduleName + "/filters/" + SET_STORAGE_NAME_FILTERS,
      this.moduleName
    );

    this.$nextTick(function () {
      window.addEventListener("resize", this.getPanelWidth);
      //Init
      this.getPanelWidth();
    });
  },
  methods: {
    getPanelWidth() {
      // eslint-disable-next-line no-undef
      this.panelWidth = $(this.$el).parent().width();
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getPanelWidth);
  },
};
</script>

<style lang="scss">
.filter-button {
  bottom: 0;
  border: 0;
  background-color: #4a90e2;
  color: white;
  width: 100%;
  height: 40px;
  cursor: pointer;
  margin-top: 10px;
}
.filters-panel {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  form {
    flex-grow: 2;
    padding: 30px;
    padding-top: 10px;
    overflow: hidden;
    overflow-y: auto;
    max-width: 300px;
    height: 100%;
    min-width: 300px;
    // width: 300px;
  }
}
.page-aside {
  position: fixed;
  top: 66px;
  left: 90px;
  padding-left: 10px;
  z-index: 998;
  width: 260px;
  height: -webkit-calc(100% - 66px);
  height: calc(100% - 66px);
  overflow-y: auto;
  visibility: visible;
  border-color: transparent;
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
  box-shadow: 1px 0 3px rgba(0, 0, 0, 0.2);
}

.filter-panel-switch {
  z-index: 1100;
  position: absolute;
  top: -webkit-calc(50% - 25px);
  top: calc(50% - 25px);
  left: -webkit-calc(100%);
  left: calc(100%);
  padding: 15px 8px 15px 4px;
  display: block !important;
  line-height: 1;
  cursor: pointer;
  background-color: white;
  border-radius: 0 100px 100px 0;
  -webkit-box-shadow: 1px 0 3px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 0 3px rgba(0, 0, 0, 0.2);
}
.filter-list {
  padding-left: 0;
}
</style>
